import * as RadixAccordion from '@radix-ui/react-accordion';
import { AccordionProps } from './Accordion.types';
import { accordion } from './Accordion.styles';
import { AddIcon } from '@onbeam/icons/business';
import { cx } from '@onbeam/business-styled-system/css';
import { SubtractIcon } from '@/icons';

export const Accordion = ({
  title,
  children,
  className,
  ...props
}: AccordionProps) => {
  const classes = accordion();

  return (
    <RadixAccordion.Item className={cx(classes.root, className)} {...props}>
      <RadixAccordion.Trigger className={classes.trigger}>
        <span>{title}</span>
        <AddIcon data-closed-icon className={classes.icon} />
        <SubtractIcon data-open-icon className={classes.icon} />
      </RadixAccordion.Trigger>
      <RadixAccordion.Content className={classes.content}>
        <div className={classes.contentInner}>{children}</div>
      </RadixAccordion.Content>
    </RadixAccordion.Item>
  );
};
